import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
  MatTableModule,
  MatRow,
  MatTableDataSource,
} from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';

import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import {
  style,
  state,
  trigger,
  transition,
  animate,
} from '@angular/animations';
import { FeedstockService } from '../../services/feedstockservice';
import { DialogService } from '../../services/dialogservice';
import { SelectControlValueAccessor } from '@angular/forms';
import { NotificationService } from '../../services/notificationservice';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HaulerService } from '../../services/haulerservice';
import { HaulerList } from '../../models/hauler.model';
import { AppDialogComponent } from '../common/app-dilaog/app-dialog.component';
import { HaulerDialogComponent } from './Hauler-dilaog/hauler-dialog.component';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
import { RolePermissionsService } from '../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../interfaces/securityPermissions';
import { RoleService } from '../../services/role.service';

@Component({
  selector: 'app-markets',
  imports: [
    MatIcon,
    MatTableModule,
    MatRow,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    CommonModule,
  ],
  templateUrl: './haulers.component.html',
  styleUrl: './haulers.component.scss',
})
export class HaulersComponent {
  permissions = inject(RolePermissionsService);
  //fsLoadlist: FeedstockLoadScheduleList | undefined;
  displayedColumns: string[] = [
    'actions',
    'id',
    'name',
    'contactName',
    'contactEmail',
    'contactPhone',
    'addressLine1',
    'addressLine2',
    'state',
    'city',
    'zipCode',
  ];
  dataSource = new MatTableDataSource<any>();
  filterText = '';
  haulerList: HaulerList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Output('onFormSubmit') formEmitter = new EventEmitter<any>();
  isDataLoaded = false;
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  constructor(
    private _dialog: MatDialog,
    private haulerService: HaulerService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private rolesService: RoleService
  ) { }
  ngOnInit(): void {
    
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.Haulers, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
    
    this.getHaulers();  
  }

  getHaulers() {
    this.isDataLoaded = false;
    this.haulerService.getHaulerList().subscribe({
      next: (res: HaulerList[]) => {
        this.haulerList = res;
        if (this.isDataLoaded == false) {
        }
        this.isDataLoaded = true;

        this.dataSource = new MatTableDataSource(this.haulerList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.syncFilter();
      },
      // error: (err: HttpErrorResponse) => {
      //   console.log(err);
      //   this.notificationService.show(err.message, 'error');
      //   this.isDataLoaded = true;
      // },
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterText = filterValue; // Store the current text
    this.syncFilter();
  }
  syncFilter() {
    if (this.dataSource) {
      this.dataSource.filter = this.filterText.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }
  openContextmenu(data: any, action: any) {
    if (action == 'EDIT') {
      this.openHaulerForm(false, data);
    } else if (action == 'DELETE') {
      console.log('delte record ', data);
      this.deleteHaulerRecord(data);
    }
  }

  deleteHaulerRecord(data: any) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete market "${data.name}"?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.handleDeleteHaulerRecord(data.id);
      }
    });
  }

  handleDeleteHaulerRecord(id: any) {
    this.haulerService.deleteHauler(id).subscribe({
      next: (response: any) => {
        //this.dialogRef.close(true);
        this.formEmitter.emit({ submit: true });
        this.notificationService.show('Hauler deleted successfully', 'success');
        this.getHaulers();
      }
    });
  }

  openHaulerForm(isAdd?: any, formData?: any): void {
    console.log(
      'openHaulerForm called with isAdd:',
      isAdd,
      'formData:',
      formData
    );
    const dialogRef = this._dialog.open(HaulerDialogComponent, {
      width: '1000px',
      maxWidth: '1050px',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        title: isAdd ? 'Add Hauler' : 'Edit Hauler',
        formData: isAdd ? {} : formData || {},
        isAddForm: isAdd || false,
        canSave: this.controlPermissions.addButton || this.controlPermissions.edit
      }, // Pass your input data object here
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      if (result?.submitted && result.data) {
        console.log('Data received:', result.data);
        this.getHaulers();
      } else {
        console.log('Dialog cancelled or no data returned.');
      }
    });
  }
}
